<template>
  <div class="inviterule" v-loading="loading">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="150px"
      class="config-form"
    >
      <el-form-item label="邀请奖励积分" prop="points">
        <el-input v-model="formData.points" placeholder="请输入邀请奖励积分" />
        <div class="form-tip">邀请用户首次消费后，双方可额外获得积分</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSave" :loading="saving">
          保存配置
        </el-button>
        <el-button @click="handleReset" :loading="resetting">
          重置为默认
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { InviteRuleSpe } from '@/api';

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);

const formData = reactive<InviteRuleSpe>({
  points: '',
});

// 正整数正则
const positiveIntPattern = /^[1-9]\d*$/u;

const rules: FormRules = {
  points: [
    { required: true, message: '请输入邀请奖励积分', trigger: 'change' },
    { pattern: positiveIntPattern, message: '请输入正确的数字', trigger: 'change' },
  ],
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().inviteRuleApi.getInviteRuleinviteRule();
    const { data } = res.data;
    if (data) {
      formData.points = data.points || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().inviteRuleApi.setInviteRuleinviteRule({
      rule: formData,
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().inviteRuleApi.resetInviteRuleinviteRule();
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
